/** ****************** BEWARE ************************
Additional experiments affect caching
- Only provide experiments actively used by the API's
- Expiry must be within 90 days
- Your experiment will not be passed after the expiry
- Extend expiry via additional PR's only if necessary
- Expiry date should be in format new Date('YYYY-MM-DD')
- Use with caution; logGlobally determines if the experiment assignment should be tracked on every request
*****************************************************/
export type Experiment = { key: string; expiry?: Date; logGlobally?: boolean }

export const graphQlExperimentsWhitelist: Array<Experiment> = [
  {
    key: 'basket-personalised-promotion-model',
    expiry: new Date('2026-01-12'),
    logGlobally: true,
  },
  {
    key: 'price-trial',
    logGlobally: true,
  },
  {
    key: 'search-use-competitive-ranking',
    expiry: new Date('2025-03-20'),
    logGlobally: true,
  },
  {
    key: 'search-learning-to-rank',
    expiry: new Date('2025-05-05'),
    logGlobally: true,
  },
  {
    key: 'search-product-tile-ux',
    expiry: new Date('2025-05-26'),
    logGlobally: true,
  },
  {
    key: 'search-threshold-ranking',
    expiry: new Date('2025-06-26'),
    logGlobally: true,
  },
  {
    key: 'search-use-named-entity-recognition',
    logGlobally: true,
  },
  {
    key: 'search-use-typo-tolerance',
    logGlobally: true,
  },
  {
    key: 'search-use-smart-department-redirection',
    expiry: new Date('2025-09-20'),
    logGlobally: true,
  },
  {
    key: 'purchase-web---delivery-scheduler-flexible',
    expiry: new Date('2025-11-13'),
    logGlobally: true,
  },
  {
    key: 'search-use-relevancy-improvements',
    logGlobally: true,
  },
  {
    key: 'search-learning-to-rank-v2',
    logGlobally: true,
  },
  {
    key: 'search-use-age-selection-ux',
    logGlobally: true,
  },
  {
    key: 'fulfilment-t24-card-only-price-change-oct-2025',
    expiry: new Date('2025-11-30'),
  },
  {
    key: 'fulfilment-t24-gift-price-change-oct-2025',
    expiry: new Date('2025-11-30'),
  },
  {
    key: 'search-use-more-like-this',
    logGlobally: true,
  },
  {
    key: 'fulfilment-dynamic-date-description-oct-2025',
    expiry: new Date('2025-12-01'),
  },
]
